import clsx from "clsx";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import React from "react";

import { View } from "@/features/common/components/tailwind/View";
import { useSubscriptionCardStyles } from "@/features/subscription/styles/useSubscriptionCardStyles";

export const NewSubscriptionPlan = () => {
  const classes = useSubscriptionCardStyles();
  const { t } = useTranslation("subscriptionPlan");

  return (
    <View
      className={clsx(
        classes.subscriptionCardContainer,
        "justify-center items-center max-w-[400px]",
      )}
      style={{ minHeight: 400 }}
      // justifyContent="center"
      // alignItems="center"
      data-test-id="NewSubscriptionPlan-container"
    >
      <Image
        alt="create new subscriptionPlan"
        src="/assets/subscription/addNewSubscriptionPlan.png"
        layout="fixed"
        height={180}
        width={215}
      />

      <div className="mt-16">
        <span className="text-base">
          {t("subscriptionPlan:newSubscriptionPlan")}
        </span>
      </div>
    </View>
  );
};
